import React from 'react'
import { Link } from 'react-router-dom'

interface Breadcrumb {
  label: string
  path?: string
}

interface PageHeaderProps {
  title: string
  description?: string
  breadcrumbs?: Breadcrumb[]
  actions?: React.ReactNode
  className?: string
}

export function PageHeader({ title, description, breadcrumbs, actions, className = '' }: PageHeaderProps) {
  return (
    <div className={`flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6 ${className}`}>
      <div className="space-y-1.5">
        {/* Breadcrumbs */}
        {breadcrumbs && breadcrumbs.length > 0 && (
          <nav className="flex items-center gap-1.5 text-xs text-text-secondary select-none">
            {breadcrumbs.map((crumb, idx) => {
              const isLast = idx === breadcrumbs.length - 1
              const itemKey = crumb.path ? `crumb-${crumb.path}` : `crumb-${crumb.label}`
              return (
                <React.Fragment key={itemKey}>
                  {crumb.path && !isLast ? (
                    <Link to={crumb.path} className="hover:text-text-primary transition-colors">
                      {crumb.label}
                    </Link>
                  ) : (
                    <span className={isLast ? 'text-text-primary font-medium' : ''}>{crumb.label}</span>
                  )}
                  {!isLast && <span className="text-border">/</span>}
                </React.Fragment>
              )
            })}
          </nav>
        )}

        {/* Title */}
        <h1 className="text-2xl font-extrabold tracking-tight text-text-primary leading-none sm:text-3xl">{title}</h1>

        {/* Description */}
        {description && <p className="text-sm text-text-secondary">{description}</p>}
      </div>

      {/* Action Buttons slot */}
      {actions && <div className="flex items-center gap-3 flex-shrink-0">{actions}</div>}
    </div>
  )
}
